import { createSelector } from 'reselect';
import { type AsyncStatus } from '../reducers/requestsState';
import { selectPayPalMethodsEligibility } from './appState';
import { selectApplePayDto } from './applePay';
import {
  selectRequestStateApCanMakePayments,
  selectRequestStateApHighestVersion,
  selectLoadPayPalScriptState,
} from './requestsState';
import { selectIsPayPalPmAvailable } from './payPal';

const isFullfilledOrRejected = (s: AsyncStatus): boolean => {
  return s === 'fulfilled' || s === 'rejected';
};

export const selectAreResourcesLoaded = createSelector(
  selectIsPayPalPmAvailable,
  selectLoadPayPalScriptState,
  selectPayPalMethodsEligibility,
  selectApplePayDto,
  selectRequestStateApCanMakePayments,
  selectRequestStateApHighestVersion,
  (isPayPalPmAvailable, ppScriptState, eligibility, apDto, requestStateCanMakePayment, requestStateHighestVersion) => {
    if (isPayPalPmAvailable) {
      if (ppScriptState === 'rejected') {
        return true; // pass through, use selectPayPalPmAndScriptAvailable to check
      }
      if (
        // eligibility filled in store
        Object.keys(eligibility).length > 0 &&
        isFullfilledOrRejected(ppScriptState)
      ) {
        // revise solution
        return true;
      }
      return false;
    }
    if (
      apDto &&
      (!isFullfilledOrRejected(requestStateCanMakePayment) || !isFullfilledOrRejected(requestStateHighestVersion))
    ) {
      return false;
    }
    return true;
  },
);
